import { setupAxios } from '../app/modules/auth'
import { PartnerMasterInput, RoleMasterInput } from '../app/types/AdminModuleTypes'
import { api } from './APIMiddlewares'
import API from './APIUrl'

export async function getUsers() {
  const { token, tenantId } = setupAxios()
  return await api.get(`/users?preset=full`, token, tenantId, false)
}
export async function getPerformanceEmployees() {
  const { token, tenantId } = setupAxios()
  return await api.get(
    `/performance/employees`,
    token,
    tenantId,
    false
  )
}

export async function getPartnerUsers(id) {
  const { token, tenantId } = setupAxios()
  return await api.get(`/users?partner=${id}`, token, tenantId, false)
}

export async function getActiveUsers() {
  const { token, tenantId } = setupAxios()
  return await api.get(`/${API?.USER}?status=Active`, token, tenantId, false)
}

export async function getTeamMembers(id: String) {
  const { token, tenantId } = setupAxios()

  // Check if user is Super Admin - they should see all users
  let isSuperAdmin = false
  try {
    const currentUserRole = sessionStorage.getItem('currentUserRole')
    if (currentUserRole) {
      const roleData = JSON.parse(currentUserRole)
      const roleName = roleData.roleName;
      isSuperAdmin = ['Super Admin', 'SUPER_ADMIN', 'Admin', 'ADMIN'].some(r => r.toLowerCase() === roleName.toLowerCase())
    }
  } catch (error) {
    console.error('Error checking role:', error)
  }

  // Super Admin sees all users, others see only their associates
  const url = isSuperAdmin
    ? `/${API?.USER}?status=Active&preset=dropdown`
    : `/${API?.USER}?status=Active&preset=dropdown&associateId=${id}`

  return await api.get(url, token, tenantId, false)
}

export async function bulkUploadUsers(file: File) {
  const { token, tenantId } = setupAxios()
  const formData = new FormData()
  formData.append('file', file)
  return await api
    .post(
      `/${API.USER}/bulk-upload`,
      token,
      tenantId,
      {
        body: formData,
      },
      true,
      true
    )
    .then((res) => res)
}
export async function getUsersById(id: string | undefined) {
  const { token, tenantId } = setupAxios()
  return await api.get(`/users/${id}`, token, tenantId, false)
}

export async function getTeamOfReportingManager(id: string, manager: string) {
  const { token, tenantId } = setupAxios()
  return await api.get(`/users/rm/${id}?manager=${manager}`, token, tenantId, false)
}

export async function checkIsManager(id: string) {
  const { token, tenantId } = setupAxios()
  return await api.get(`/check-managers/${id}`, token, tenantId, false)
}

export async function getProjectManagers() {
  const { token, tenantId } = setupAxios()
  return await api.get(`/users/project-managers`, token, tenantId, false)
}
// // ✅ GET HR USERS
// export async function getHrUsers() {
//   const {token, tenantId} = setupAxios()
//   return await api.get(`/users/hr`, token, tenantId, false)
// }


export async function deleteUser(id: string) {
  const { token, tenantId } = setupAxios()
  return await api.delete(`/users/${id}`, token, tenantId, false)
}
export async function addUser(InputField: {
  firstName: string
  middleName?: string
  lastName: string
  email: string
  contact: string
  password: string
  dob: string
  gender: string
  role: string
  hr: string
  employeeCode: string
  employmentType: string
  designation: string
  startDate: string
  endDate: string
  address: string
  permanentAddress?: string | null  //Permanent Address
  inTime: string
  outTime: string
  reportingManager: string
  personalEmail: string
  band: string | null
  partner: string | null
  departmentId?: string | null  
  locationId?: string | null
  weekendDays: string[]   //Weekend Days
  shiftManagement?: string | null
  //Emergency Contact
  emergencyName?: string | null
  emergencyMobile?: string | null
  emergencyRelation?: string | null
}) {
  const { token, tenantId } = setupAxios()
  console.log('ADD USER → locationId:', InputField.locationId)
  console.log('ADD USER → weekendDays:', InputField.weekendDays) //Weekend Day

  return await api
    .post(
      `/${API.USER}`,
      token,
      tenantId,
      {
        body: JSON.stringify({
          personal: {
            firstName: InputField.firstName.trim(),
            middleName: InputField.middleName?.trim() || null,
            lastName: InputField.lastName.trim(),
            email: InputField.email,
            mobile: InputField.contact,
            password: InputField.password && InputField.password.trim() ? InputField.password : null,
            dateOfBirth: InputField.dob,
            gender: InputField.gender,
            roleId: InputField.role.toString(),
            departmentId: InputField.departmentId,
            hrId: InputField.hr ? InputField.hr : null,
            rmId: !InputField.reportingManager ? null : InputField.reportingManager,
            employmentTypeId: InputField.employmentType,
            designationId: InputField.designation,
            joiningDate: InputField.startDate,
            lastWorkingDate: !InputField.endDate ? null : InputField.endDate || null,
            inTime: InputField.inTime,
            address: !InputField?.address ? null : InputField.address,
            permanentAddress: InputField.permanentAddress || null,  //Permanent Address
            outTime: InputField.outTime,
            workingShiftId: InputField.shiftManagement || null,
            employeeCode: InputField?.employeeCode,
            personalEmail: !InputField?.personalEmail ? null : InputField.personalEmail,
            locationId: InputField.locationId || null,
            weekendDays: InputField.weekendDays, //Weekend Days

            //Emergency Contact
            // emergencyName: InputField.emergencyName || null,
            // emergencyMobile: InputField.emergencyMobile || null,
            // emergencyRelation: InputField.emergencyRelation || null,
            emergencyName: InputField.emergencyName ?? undefined,
            emergencyMobile: InputField.emergencyMobile ?? undefined,
            emergencyRelation: InputField.emergencyRelation ?? undefined,
          },
        }),
      },
      false
    )

    .then((res) => res)
}
// api.js
export async function updateUserById(
  InputField: {
    firstName: string
    middleName?: string
    lastName: string
    email: string
    contact: string
    password: string
    dob: string
    gender: string
    role: string
    employmentType: string
    designation: string
    startDate: string
    endDate: string
    inTime: string
    outTime: string
    reportingManager: string
    personalEmail: string
    band: string | null
    partner: string | null
    locationId?: string | null
    permanentAddress?: string | null
    emergencyName?: string | null
    emergencyMobile?: string | null
    emergencyRelation?: string | null
    shiftManagement?: string | null
  },
  id: string
) {
  const { token, tenantId } = setupAxios()
  return await api
    .put(
      `/users/${id}`,
      token,
      tenantId,
      {
        body: JSON.stringify({
          firstName: InputField.firstName.trim(),
          middleName: InputField.middleName?.trim() || null,
          lastName: InputField.lastName.trim(),
          email: InputField.email,
          contact: InputField.contact,
          password: InputField.password,
          dob: InputField.dob,
          role: {
            id: InputField.role.toString(),
          },
          partner: InputField.partner ? { id: InputField.partner.toString() } : null,
          gender: InputField.gender,
          reportingManager: InputField.reportingManager,
          employmentType: InputField.employmentType,
          designation: { id: InputField.designation },
          startDate: InputField.startDate,
          endDate: InputField.endDate,
          inTime: InputField.inTime,
          outTime: InputField.outTime,
          workingShiftId: InputField.shiftManagement || null,
          personalEmail: InputField.personalEmail,
          // band: InputField.band ? {id: InputField.band.toString()} : null,
          locationId: InputField.locationId || null,
          permanentAddress: InputField.permanentAddress || null, 
          emergencyName: InputField.emergencyName ?? undefined,
          emergencyMobile: InputField.emergencyMobile ?? undefined,
          emergencyRelation: InputField.emergencyRelation ?? undefined,
        }),
      },
      false
    )
    .then((res) => res)
}
export const updateBankDetailsApi = async (userId, bankDetailData, token, tenantId) => {
  return await api
    .patch(`users/${userId}/bank`, token, tenantId, bankDetailData, false)
    .then((res) => res)
}
export async function updatePassword(
  InputField: {
    password: string
  },
  id: string
) {
  const { token, tenantId } = setupAxios()
  return await api
    .put(
      `/${API.USER}/${id}/change-password`,
      token,
      tenantId,
      {
        body: JSON.stringify({
          password: InputField.password,
        }),
      },
      false
    )
    .then((res) => res)
}

export async function changeUserStatusApi(userId: string, status: 'Active' | 'Inactive' | 'Suspended' | 'Deleted') {
  const { token, tenantId } = setupAxios()
  return await api
    .put(
      `/${API.USER}/${userId}/status`,
      token,
      tenantId,
      {
        body: JSON.stringify({ status }),
      },
      true
    )
    .then((res) => res)
}

export async function getRoles() {
  const { token, tenantId } = setupAxios()
  return await api.get(`/${API.ROLES}/all`, token, tenantId, false).then((res) => res)
}
export async function getRolesById(id: string) {
  const { token, tenantId } = setupAxios()
  return await api.get(`/${API.ROLES}/${id}`, token, tenantId, false).then((res) => res)
}

export async function deleteRoles(id: string) {
  const { token, tenantId } = setupAxios()
  return await api.delete(`/${API.ROLES}/${id}`, token, tenantId, true).then((res) => res)
}
export async function addRoles(formField: RoleMasterInput, permission: string[]) {
  const { token, tenantId } = setupAxios()

  return await api
    .post(
      `/${API.ROLES}`,
      token,
      tenantId,
      {
        body: JSON.stringify({
          name: formField.roleName.toUpperCase().trim(),
          permissions: permission,
        }),
      },
      true
    )
    .then((res) => res)
}
export async function checkIsRoleDuplicate(
  formField: RoleMasterInput,
  permission: {
    features: { id: string }
    permissions: string[]
  }[]
) {
  const { token, tenantId } = setupAxios()
  return await api
    .post(
      `/${API.ROLES}/check_duplicate`,
      token,
      tenantId,
      {
        body: JSON.stringify({
          name: formField.roleName.toUpperCase().trim(),
          permission,
        }),
      },
      false
    )
    .then((res) => res)
}
export async function updateRolesById(
  formField: RoleMasterInput,
  id: string,
  permission: string[]
) {
  const { token, tenantId } = setupAxios()
  // const permissionArray = permission.map((permissionItem) => ({
  //   features: permissionItem.features,
  //   permissions: permissionItem.permissions.map((permission) => permission.toString()), // Convert each permission to string
  // }))
  return await api
    .put(
      `/${API.ROLES}/${id}`,
      token,
      tenantId,
      {
        body: JSON.stringify({
          name: formField.roleName.toUpperCase().trim(),
          permissions: permission,
        }),
      },
      true
    )
    .then((res) => res)
}

export async function getFeatures() {
  const { token, tenantId } = setupAxios()
  return await api.get(`/${API.PERMISSION}`, token, tenantId, false).then((res) => res)
}
export async function getFeaturesByUserId(id: string) {
  const { token, tenantId } = setupAxios()
  return await api
    .get(`/${API.USER}/${id}/${API.PERMISSION}`, token, tenantId, false)
    .then((res) => res)
}
export async function getFeatureLevels() {
  const { token, tenantId } = setupAxios()
  return await api.get(`/roles`, token, tenantId, false).then((res) => res)
}
export async function getModules() {
  const { token, tenantId } = setupAxios()
  return await api.get(`/${API.MODULE}`, token, tenantId, false).then((res) => res)
}
export async function getFeaturesByModuleId(id: string) {
  const { token, tenantId } = setupAxios()
  return await api.get(`/${API.MODULE}/${id}/features`, token, tenantId, false).then((res) => res)
}
export async function getSalaryStructure(userId: string) {
  const { token, tenantId } = setupAxios()
  return await api.get(`/structure/${userId}`, token, tenantId, false)
}

export async function getPartners() {
  const { token, tenantId } = setupAxios()
  return await api.get(`/${API.PARTNER}`, token, tenantId, false).then((res) => res)
}
export async function getPartnersById(id: string) {
  const { token, tenantId } = setupAxios()
  return await api.get(`/${API.PARTNER}/${id}`, token, tenantId, false).then((res) => res)
}
export async function deletePartners(id: string) {
  const { token, tenantId } = setupAxios()
  return await api.delete(`/${API.PARTNER}/${id}`, token, tenantId, true).then((res) => res)
}
export async function addPartners(formField: PartnerMasterInput) {
  const { token, tenantId } = setupAxios()
  let formData = new FormData()
  formData.append('partnerName', formField.partnerName)
  formData.append('aadharCardFile', formField.aadharDoc ?? '')
  formData.append('aadharCard', formField.aadharNo)
  formData.append('registerAddress', formField.address)
  formData.append('partnerCompany', formField.companyName)
  formData.append('contact', formField.contactNo)
  formData.append('gstApplicable', formField.gstApplicable)
  formData.append('email', formField.email)
  formData.append('gstNumberFile', formField.gstDoc ?? '')
  formData.append('gstNumber', formField.gstNo)
  formData.append('gstReason', formField.gstReason)
  formData.append('panCardFile', formField.panDoc ?? '')
  formData.append('panCard', formField.panNo?.toUpperCase())
  formData.append('password', 'Password@123')
  formData.append('createdBy[id]', formField?.createdBy)
  return await api
    .post(
      `/${API.PARTNER}`,
      token,
      tenantId,
      {
        body: formData,
      },
      true,
      true
    )
    .then((res) => res)
}
export async function updatePartnersById(formField: PartnerMasterInput, id: string) {
  const { token, tenantId } = setupAxios()
  let formData = new FormData()
  formData.append('partnerName', formField.partnerName)
  formData.append('aadharCardFile', formField.aadharDoc ?? '')
  formData.append('aadharCard', formField.aadharNo)
  formData.append('registerAddress', formField.address)
  formData.append('partnerCompany', formField.companyName)
  formData.append('contact', formField.contactNo)
  formData.append('gstApplicable', formField.gstApplicable)
  formData.append('email', formField.email)
  formData.append('gstNumberFile', formField.gstDoc ?? '')
  formData.append('gstNumber', formField.gstNo)
  formData.append('gstReason', formField.gstReason)
  formData.append('password', 'Password@123')
  formData.append('panCardFile', formField.panDoc ?? '')
  formData.append('panCard', formField.panNo?.toUpperCase())
  formData.append('createdBy[id]', formField?.createdBy)
  return await api
    .put(
      `/${API.PARTNER}/${id}`,
      token,
      tenantId,
      {
        body: formData,
      },
      true,
      true
    )
    .then((res) => res)
}

export async function assignUserRole(userId: string, roleId: string) {
  const { token, tenantId } = setupAxios()

  return await api
    .put(`/${API.USER}/${userId}/role/${roleId}`, token, tenantId, {}, false)
    .then((res) => res)
}

export async function getProbationaryUsers() {
  const { token, tenantId } = setupAxios()
  return await api.get(`/${API.USER}/probationary`, token, tenantId, false)
}

export async function getFullTimeUsers() {
  const { token, tenantId } = setupAxios()
  return await api.get(`/${API.USER}/fulltime`, token, tenantId, false)
}

export async function updateEmploymentStatus(userId: string, status: 'PROBATIONARY' | 'FULL_TIME' | 'LAID_OFF', file?: File) {
  const { token, tenantId } = setupAxios()
  let options: any
  let isMultipart = false
  if (status === 'FULL_TIME' && file) {
    const fd = new FormData()
    fd.append('file', file)
    fd.append('status', status)
    options = { body: fd }
    isMultipart = true
  } else {
    options = { body: JSON.stringify({ status }) }
  }
  return await api.post(`/${API.USER}/${userId}/employment-status`, token, tenantId, options, true, isMultipart)
}

export async function getProbationAlertsCount() {
  const { token, tenantId } = setupAxios()
  return await api.get(`/${API.USER}/probationary/alerts/count`, token, tenantId, false)
}

// Bulk update working shift for multiple users
export async function bulkUpdateWorkingShift(userIds: string[], workingShiftId: string) {
  const { token, tenantId } = setupAxios()
  return await api
    .post(
      `/${API.USER}/bulk-update-working-shift`,
      token,
      tenantId,
      {
        body: JSON.stringify({
          userIds,
          workingShiftId,
        }),
      },
      true
    )
    .then((res) => res)
}

//
export async function getDashboardUsers() {
  const { token, tenantId } = setupAxios();
  return await api.get(
    `/${API.USER}?preset=full`,
    token,
    tenantId,
    false
  );
}
export async function getUserById(id: string) {
  const { token, tenantId } = setupAxios();
  return await api.get(
    `/${API.USER}/${id}`,
    token,
    tenantId,
    false
  );
}
